import React, { Suspense, useState, useEffect } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { useLocation } from 'react-router-dom';
import * as layoutThunk from '@reducers/layout/layoutThunk';

import { ISearchResponse } from '@models/scraperModel/searchModel';
import { IAPPResponse } from '@models/scraperModel/appModel';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));

const AppListBox = React.lazy(() => import('@components/template/layout/appInfoHalfModule/appListBox'));
const AppInfoStateList = React.lazy(() => import('@components/template/layout/appInfoHalfModule/appInfoStateList'));

const RankingAndRating = React.lazy(() => import('@components/template/app/app/rankingAndRating'));
const RosettaScore = React.lazy(() => import('@components/template/app/app/rosettaScore'));
const AverageRating = React.lazy(() => import('@components/template/app/app/averageRating'));
const Description = React.lazy(() => import('@components/template/app/app/description'));

const AppProfile = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedAppInfo, selectedCountry, selectedLanguage } = useSelector((state: RootState) => state.LAYOUT);

  const location = useLocation();

  useEffect(() => {
    if (!!location) {
      if (!!location?.state) {
        //@ts-ignore
        const { reqAppId, reqProvider_type } = location?.state;
        dispatch(
          layoutThunk.getHeaderSearchedAppInfo({
            appId: reqAppId,
            provider_type: reqProvider_type,
            country: selectedCountry,
            lang: selectedLanguage,
          })
        );
      }
    }
  }, [location]);

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <div className="half_module_bx">
        <Suspense fallback={<LoaderComponent />}>
          <AppListBox />
        </Suspense>
        <Suspense fallback={<LoaderComponent />}>
          <AppInfoStateList />
        </Suspense>
      </div>
      {selectedAppInfo && (
        <>
          <Suspense fallback={<LoaderComponent />}>
            <RankingAndRating appId={selectedAppInfo.appId} type={selectedAppInfo.provider_type} />
          </Suspense>
          <Suspense fallback={<LoaderComponent />}>
            <RosettaScore appId={selectedAppInfo.appId} type={selectedAppInfo.provider_type} />
          </Suspense>
          <Suspense fallback={<LoaderComponent />}>
            <AverageRating
              appInfo={{
                appId: selectedAppInfo.appId,
                providerType: selectedAppInfo.provider_type,
                histogramData: selectedAppInfo.histogram,
              }}
            />
          </Suspense>
          <Suspense fallback={<LoaderComponent />}>
            <Description appId={selectedAppInfo.appId} type={selectedAppInfo.provider_type} />
          </Suspense>
        </>
      )}
    </>
  );
};

export default AppProfile;
